module.exports = __webpack_public_path__ + "img/person-icon.b4ba26a3.svg";